var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.usageStats && _vm.usageStats[_vm.column] != null
    ? _c(
        "div",
        { staticClass: "p-l-10 live-counter-cell d-flex flex-row" },
        [
          _c(
            "LiveCounter",
            { attrs: { flickerClass: "flicker-table-data" } },
            [
              _c("CappedValueDisplay", {
                attrs: {
                  value: _vm.usageStats[_vm.column],
                  cap: _vm.capSetting,
                  isAmountType: _vm.isAmountType,
                  column: _vm.column
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }